"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DVLSectionTree = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useDataTree_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTree"));
const Dots_1 = __importDefault(require("@opsbase/web-ui/Dots"));
const react_1 = __importStar(require("react"));
const DVLGroupSection_1 = __importDefault(require("./DVLGroupSection"));
const DVLItemSection_1 = __importDefault(require("./DVLItemSection"));
function DVLSectionTree(props) {
    const { nodeKey, itemComponent, groupComponent } = props;
    const dt = (0, useDataTree_1.default)();
    const node = dt.nodesByKey.get(nodeKey);
    const isLoading = dt.dataStatus.loadingGroups;
    return (0, react_1.useMemo)(() => {
        var _a;
        if (isLoading) {
            return (react_1.default.createElement(Dots_1.default, { style: {
                    margin: '32px auto',
                }, color: lib_palette_1.default.LavendarGrey }));
        }
        // Node is a group tree branch (a node with child nodes)
        if ((_a = node.childNodes) === null || _a === void 0 ? void 0 : _a.length) {
            return (react_1.default.createElement(DVLGroupSection_1.default, { component: groupComponent, nodeKey: nodeKey }, node.childNodes.map(childNode => (react_1.default.createElement(DVLSectionTree, { groupComponent: groupComponent, itemComponent: itemComponent, key: childNode.nodeKey, nodeKey: childNode.nodeKey })))));
        }
        // Node is a group tree leaf (a node with a group and items)
        else if (node.group) {
            return (react_1.default.createElement(DVLGroupSection_1.default, { component: groupComponent, nodeKey: nodeKey },
                react_1.default.createElement(DVLItemSection_1.default, { component: itemComponent, nodeKey: nodeKey })));
        }
        // Node is a simple list of items
        else {
            return react_1.default.createElement(DVLItemSection_1.default, { component: itemComponent, nodeKey: nodeKey });
        }
    }, [groupComponent, isLoading, itemComponent, node, nodeKey]);
}
exports.DVLSectionTree = DVLSectionTree;
exports.default = DVLSectionTree;
